import React, { FC, useEffect, useState } from 'react';
import { DateRangeSelector, DateRangeType } from '@cokitchen/cokitchen-components';
import { CoKitchenPolygons } from 'models/cokitchen.model';
import { getGeneralSurgeSnapshot, getPolygonSurge } from 'utils/firebase';
import { DeliverySchedulePayload } from 'components/logistics/surge/delivery-settings/types';
import { STORAGE_KEYS } from 'utils/constants';
import { PolygonsTab } from 'components/base/polygons-tab';
import DeliverySettings from 'components/logistics/surge/delivery-settings';
import useDashboardContext from 'contexts/dashboard.context';

type TempProps = {
  activePolygon: CoKitchenPolygons;
  dateRange: DateRangeType;
};
type Props = {
  value: TempProps;
  onChange: (e: TempProps) => void;
};

const OverviewHeader: FC<Props> = ({ value, onChange }) => {
  const { activeCokitchen } = useDashboardContext();
  const [deliveryPolygons, setDeliveryPolygons] = useState<string[]>([]);

  const updateDeliveryPolygon = (id: string, delivery: boolean) => {
    if (!delivery) {
      if (!deliveryPolygons.includes(id)) setDeliveryPolygons((prev) => [...prev, id]);
    } else {
      const newVal = deliveryPolygons.filter((d) => id !== d);
      setDeliveryPolygons(() => newVal);
    }
  };

  const refreshPolygonSurge = () => {
    const polygons = activeCokitchen.cokitchen_polygons;
    if (!polygons) return;
    getGeneralSurgeSnapshot(activeCokitchen.id, (doc: DeliverySchedulePayload) => {
      updateDeliveryPolygon('All', doc.delivery);
    });
    for (let i = 0; i < polygons.length; i++) {
      const p = polygons[i];

      getPolygonSurge(p.id, (doc: DeliverySchedulePayload) => {
        updateDeliveryPolygon(p.name, doc.delivery);
      });
    }
  };

  const getStoredSurgeData = async () => {
    const data = localStorage.getItem(STORAGE_KEYS.DELIVERY_POLYGONS_STATE);
    setDeliveryPolygons(data ? JSON.parse(data) : []);
  };

  const updateStoredData = async () => {
    localStorage.setItem(STORAGE_KEYS.DELIVERY_POLYGONS_STATE, JSON.stringify(deliveryPolygons));
  };

  useEffect(() => {
    updateStoredData();
  }, [deliveryPolygons]);

  useEffect(() => {
    getStoredSurgeData();
    const toBeCleared = setTimeout(() => {
      refreshPolygonSurge();
    }, 8000);

    return () => {
      clearTimeout(toBeCleared);
    };
  }, [activeCokitchen]);
  return (
    <div>
      <div className='flex flex-col gap-4 lg:flex-row lg:items-center justify-between mb-4 lg:mb-8'>
        <div className='flex items-center'>
          <label htmlFor='' className='mr-3'>
            Overview period:
          </label>
          <DateRangeSelector
            onChange={(dateRange) => onChange({ ...value, dateRange })}
            defaultRange={value.dateRange.range}
            showTime
          />
        </div>
      </div>
      <div
        className='flex flex-col lg:flex-row gap-4 justify-between pb-1 lg:pb-0 border-b border-gray-border'
        key={activeCokitchen.id}>
        <PolygonsTab
          className='w-[85%]'
          activePolygon={value.activePolygon}
          dottedPolygons={deliveryPolygons}
          setActivePolygon={(activePolygon) => onChange({ ...value, activePolygon })}
          hasAll
          hideHr
        />

        <DeliverySettings defaultPolygon={value.activePolygon} />
      </div>
    </div>
  );
};

export default OverviewHeader;
